import stateNicknames from 'messages/stateNicknames.json'
import innerHTML from 'utils/DOM/innerHTML'

function updateLocationCopies({ location, selectors = {} }) {
  const copies = {
    zip: location.zip_code,
    city: location.city,
    state: location.state,
    stateAcronym: location.state_acronym,
    cityStateZip: `${location.city}, ${location.state_acronym} ${location.zip_code}`,
    cityState: `${location.city}, ${location.state_acronym}`,
    zipState: `${location.zip_code}, ${location.state}`,
    cityNickname: stateNicknames[location.state_acronym]
  }

  for (const [key, value] of Object.entries(copies)) {
    innerHTML(selectors[key] || `.${key}`, value)
  }
}

export default updateLocationCopies
